<template>
  <div class="salaries-tooltip" :style="style">
    <slot></slot>
    <div class="salaries-tooltip__beak"></div>
  </div>
</template>

<script>
export default {
  name: 'SalariesTooltip',
  props: {
    zoom: {
      type: Number,
      default: 0,
    },
    blur: {
      type: Number,
      default: 0,
    },
    top: {
      type: String,
      default: '',
    },
    left: {
      type: String,
      default: '',
    },
  },
  computed: {
    style() {
      return {
        top: `${this.top}`,
        left: `${this.left}`,
        filter: `blur(${this.blur}px)`,
        zoom: `${this.zoom}%`,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.salaries-tooltip {
  background: #32353c;
  color: #adaeb1;
  padding: 15px 15px;
  border-radius: 5px;
  position: absolute;
  font-weight: 500;

  .salaries-tooltip__beak {
    width: 20px;
    height: 20px;
    background: #32353c;
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: rotate(45deg) translateX(-50%);
    border-radius: 5px;
  }
}
</style>
